import * as web3 from '@solana/web3.js'
import * as borsh from "@coral-xyz/borsh"
import { BILLBOARD_PROGRAM_ID } from "../utils/constants";

export class ProviderAdRelation {
    provider: web3.PublicKey
    ad: web3.PublicKey
    state: number
    publicKey?: web3.PublicKey


    constructor(
        provider: web3.PublicKey,
        ad: web3.PublicKey,
        state: number
    ) {
        this.provider = provider
        this.ad = ad
        this.state = state
    }

    static findAddress(provider: web3.PublicKey, adCampaign: web3.PublicKey) {
        return web3.PublicKey.findProgramAddressSync(
            [Buffer.from("relation"), provider.toBuffer(), adCampaign.toBuffer()],
            new web3.PublicKey(BILLBOARD_PROGRAM_ID)
        );
    }

    static borshProviderSchema = borsh.struct([
        borsh.str("discriminator"),
        borsh.publicKey("provider"),
        borsh.publicKey("ad"),
        borsh.u8("state"),
    ])

    static deserialize(buffer?: Buffer): ProviderAdRelation | null {
        if (!buffer) {
            return null
        }
        try {
            const { provider, ad, state } = this.borshProviderSchema.decode(buffer)
            return new ProviderAdRelation(provider, ad, state)
        } catch (e) {
            console.log("Deserialization error:", e)
            console.log(buffer)
            return null
        }
    }
}